import { render, staticRenderFns } from "./BlockType4Grid.vue?vue&type=template&id=286b322a&scoped=true"
import script from "./BlockType4Grid.vue?vue&type=script&lang=ts"
export * from "./BlockType4Grid.vue?vue&type=script&lang=ts"
import style0 from "./BlockType4Grid.vue?vue&type=style&index=0&id=286b322a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286b322a",
  null
  
)

export default component.exports